import { getBuildingList, addBuilding, removeBuilding, updateBuilding }  from 'Api/companyApi'
import { formatUpdateBuilding, formatAddBuilding } from 'Formatters/buildingFormatter'
import { parseBuildingList }  from 'Parsers/buildingParser'

const state = {
  requesting: {
    buildingList: false,
    addBuilding: false,
    editBuilding: false,
    deleteBuilding: false,
  },

  pagination: {
    current: 1,
    limit: 1,
  },

  searchSort: false,
  searchTerm: '',

  sortList: [
    { id: 0, name: 'Mais recentes', value: false },
    { id: 1, name: 'Ordem alfabética',  value: true },
  ],

  buildingList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_building_list(state, buildingList) {
    state.buildingList = buildingList
  },
  set_pagination(state, pagination) {
    state.pagination = pagination
  },
  set_search_term(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  set_search_sort(state, searchSort) {
    state.searchSort = searchSort
  },
}

const actions = {
  async getBuildingList({ commit }) {
    const { searchTerm, searchSort, pagination } = state
    commit('request_start', 'buildingList')

    try {
      let options = {
        pageSize: 9
      }

      if (searchTerm !== '') {
        options.filter = searchTerm
      }

      if (searchSort !== '') {
        options.alphabeticalOrder = searchSort
      }

      const { data } = await getBuildingList(pagination.current, options)

      const buildingList = parseBuildingList(data)
      commit('set_building_list', buildingList)
      commit('set_pagination', { current: data.page, limit: data.pageCount })

      commit('request_success', 'buildingList')

      return buildingList
    } catch (err) {
      commit('request_failure', 'buildingList')

      throw err
    }
  },

  async searchBuilding({ commit, dispatch }, query) {
    commit('set_search_term', query)

    try {
      const result = await dispatch('getBuildingList')

      return result
    } catch (err) {
      throw err
    }
  },

  async paginate({ state, commit, dispatch }, page) {
    const { pagination } = state
    commit('set_pagination', Object.assign({}, pagination, { current: page }))

    try {
      const result = await dispatch('getBuildingList')

      return result
    } catch (err) {
      throw err
    }
  },

  async addBuilding({ commit }, building) {
    commit('request_start', 'addBuilding')

    try {
      const data = formatAddBuilding(building)
      const result = await addBuilding(data)

      commit('request_success', 'addBuilding')

      return result
    } catch (err) {
      commit('request_failure', 'addBuilding')

      throw err
    }
  },

  async editBuilding({ commit }, building) {
    commit('request_start', 'editBuilding')

    try {
      const data = formatUpdateBuilding(building)
      const result = await updateBuilding(data)

      commit('request_success', 'editBuilding')

      return result
    } catch (err) {
      commit('request_failure', 'editBuilding')
      throw err
    }
  },

  async removeBuilding({ commit }, id) {
    commit('request_start', 'deleteBuilding')

    try {
      const result = await removeBuilding(id)

      commit('request_success', 'deleteBuilding')

      return result
    } catch (err) {
      commit('request_failure', 'deleteBuilding')

      throw err
    }
  },

  updateSort({ commit }, value) {
    commit('set_search_sort', value)
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}